<form class="vl-form" @submit="onSubmit">
    <vl-modal :id="addMessageModal" mod-medium :closable="true">
        <vl-title tag-name="h3" v-if="isNewMessage">Nieuw bericht</vl-title>
        <vl-title tag-name="h3" v-else>Bericht</vl-title>

        <vl-form-grid mod-stacked>
            <vl-column width="8">
                <vl-form-grid mod-stacked>
                    <vl-column width="6">
                        <aeg-field-validation-wrapper :error-message="errors.dateFrom" mod-required name="Begindatum"
                                                      #default="{hasErrors}">
                            <vl-datepicker visual-format="d/m/Y H:i" v-model="dateFrom" v-bind="dateFromProps"
                                           :mod-error="hasErrors" enable-time id="date-from"/>
                        </aeg-field-validation-wrapper>
                    </vl-column>
                    <vl-column width="6">
                        <aeg-field-validation-wrapper :error-message="errors.dateTo" name="Einddatum"
                                                      #default="{hasErrors}">
                            <vl-datepicker visual-format="d/m/Y H:i" v-model="dateTo" v-bind="dateToProps" enable-time
                                           id="date-to"/>
                        </aeg-field-validation-wrapper>
                    </vl-column>
                </vl-form-grid>
            </vl-column>

            <vl-column width-l="12">
                <aeg-field-validation-wrapper :error-message="errors.title" mod-required name="Titel"
                                              #default="{hasErrors}">
                    <vl-input-field name="title" v-model="title" v-bind="titleProps" :mod-error="hasErrors" mod-block/>
                </aeg-field-validation-wrapper>
            </vl-column>

            <vl-column width-l="12">
                <aeg-field-validation-wrapper :error-message="errors.message" mod-required name="Bericht"
                                              #default="{hasErrors}">
                    <vl-textarea rows="6" name="text" id="text" v-model="message" v-bind="messageProps"
                                 :mod-error="hasErrors" mod-block/>
                </aeg-field-validation-wrapper>
            </vl-column>

            <vl-column width-s="12" width-m="8" width-l="12">
                <vl-form-message-label>Preview</vl-form-message-label>
                <vl-alert :closable="false" :title="title" mod-warning>
                    <div v-html="message"></div>
                </vl-alert>
            </vl-column>

        </vl-form-grid>
        <template v-slot:modal-footer>
            <vl-action-group>
                <vl-button type="submit" mod-large :mod-disabled="invalidForm">Bewaren</vl-button>
                <vl-button @click.prevent="removeAnnouncement" mod-large mod-secondary
                           :mod-loading="isDeletingAnnouncement" :mod-disabled="isDeletingAnnouncement"
                           :mod-error="!isDeletingAnnouncement" v-if="!isNewMessage">Verwijderen
                </vl-button>
                <vl-link @click.prevent="onCloseModal" icon="cross" mod-icon-before>
                    Annuleer
                </vl-link>
            </vl-action-group>
        </template>
    </vl-modal>
</form>